'use client';

import { useEffect } from 'react';
import { AlertTriangle, RefreshCw, Home } from 'lucide-react';
import Link from 'next/link';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('Application error:', error);
  }, [error]);

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ background: 'var(--bg-base)' }}>
      <div className="max-w-md w-full text-center">
        <div
          className="w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-6"
          style={{ background: 'var(--bearish-muted)', border: '1px solid var(--bearish-muted)' }}
        >
          <AlertTriangle size={28} style={{ color: 'var(--bearish)' }} />
        </div>

        <h1 className="text-2xl font-bold mb-2 font-heading" style={{ color: 'var(--text-primary)' }}>
          Something went wrong
        </h1>
        <p className="text-sm mb-8" style={{ color: 'var(--text-secondary)' }}>
          An unexpected error occurred. This has been logged automatically.
        </p>

        <div className="flex items-center justify-center gap-3">
          <button
            onClick={() => reset()}
            className="btn-primary inline-flex items-center gap-2 px-5 py-2.5 text-sm"
          >
            <RefreshCw size={14} />
            Try Again
          </button>
          <Link
            href="/"
            className="btn-ghost inline-flex items-center gap-2 px-5 py-2.5 text-sm font-medium"
          >
            <Home size={14} />
            Go Home
          </Link>
        </div>
      </div>
    </div>
  );
}
